export default {
  prefixCookie: 'Remax_cookies_'
};